import React from "react"
import { Outlet } from "react-router-dom"
import { styled, Box } from "@mui/material"

import { IndoorMapContainer } from "containers/IndoorMapContainer"
import Div100vh from "react-div-100vh"
import { AppNavigation } from "../containers/AppNavigation"
import { SearchContainer } from "containers/SearchContainer"

const OutletWrapper = styled(Box)(({ theme }) => ({
  position: "relative",
}))

export const AppLayout = () => {
  return (
    <Div100vh data-name="AppLayout">
      <IndoorMapContainer />
      <OutletWrapper>
        <Outlet />
      </OutletWrapper>
      <SearchContainer />
      <AppNavigation />
    </Div100vh>
  )
}
